import { DialogContent, styled } from "@mui/material";
import { surface } from "@/theme";

interface ModalContentProps {
  flush?: boolean;
}

/** Canonical dialog body inset; `flush` is reserved for edge-to-edge content. */
export const ModalContent = styled(DialogContent, {
  shouldForwardProp: prop => prop !== "flush",
})<ModalContentProps>(({ theme, flush = false }) => ({
  display: "flex",
  flexDirection: "column",
  gap: flush ? 0 : theme.spacing(3),
  // MUI applies `.MuiDialogTitle-root + & { padding-top: 0 }`. Doubling the
  // generated class keeps the canonical inset authoritative in the real
  // title/content composition while still allowing the explicit flush mode.
  "&&": {
    padding: flush ? 0 : surface.padding,
  },
  [theme.breakpoints.down("md")]: {
    "&&": {
      padding: flush ? 0 : surface.paddingCompact,
    },
  },
}));
